export interface NotificationSchema {
  id: number;
  title: string;
  content: string;
  miscellaneous_details: any;
  notification_type: string;
  read: boolean;
  redirection: string;
  created_at: string;
  source_type: string;
  source_id: number;
  files: File[]
}

export interface NotificationPreferences {
  tag_notifications_enabled: boolean;
  task_status_notifications_enabled: boolean;
  email_notifications_enabled: boolean;
  push_notifications_enabled: boolean;
}

export const NotificationTypeTags: {
  [key: string]: { displayName?: string; background: string; color: string };
} = {
  TAG: {
    displayName: "Tagged",
    background: "#E0FFD5",
    color: "#228500",
  },
  STATUS_UPDATE: {
    displayName: "Status Changed",
    background: "#FFBEC8",
    color: "#8D0016",
  },
  QUOTE: {
    displayName: "Quote",
    background: "#FFD1F6",
    color: "#88006D",
  },
  COMMENT: {
    displayName: "Comment",
    background: "#0231A81F",
    color: "#0231A8",
  },
  ARTWORK: {
    displayName: "Artwork",
    background: "#CDF5FF",
    color: "#1086A3",
  },
  SKUARTWORK:{
    displayName: "Artwork",
    background: "#CDF5FF",
    color: "#1086A3",
  },
  PURCHASE_ORDER: {
    displayName: "Purchase Order",
    background: "#965DF8",
    color: "#FFFFFF",
  },
   PROCUREMENTREQUEST: {
    displayName: "Purchase Order",
    background: "#965DF8",
    color: "#FFFFFF",
  },
  TASK_ASSIGNED: {
    displayName: "Task Assigned",
    background: "#DBEBFF",
    color: "#438CEB",
  },
};


export const NOTIFICATION_PREFERENCES_FORM = {
  tag_notifications_enabled: false,
  task_status_notifications_enabled: false,
  email_notifications_enabled: false,
  push_notifications_enabled: false,
};

export const TaskStatusColorSchema: {
  [key: string]: { background: string; color: string };
} = {
  'Enquiry Received': {
    background: '#FF6262',
    color: '#F6F6F6',
  },
  'RFQ Generated': {
    background: '#FF6262',
    color: '#F6F6F6',
  },
  'RFQ Review': {
    background: '#FF8359',
    color: '#FFFFFF',
  },
  'RFQ Incomplete': {
    background: '#FFAC82',
    color: '#373737',
  },
  'Sourcing Rejected': {
    background: '#FFA4A4',
    color: '#202020',
  },
  'RFQ Submitted': {
    background: '#FFCB98',
    color: '#484848',
  },
  'Offer Generated': {
    background: '#FFDDB7',
    color: '#484848',
  },
  'Offer Submitted': {
    background: '#FFE6CE',
    color: '#484848',
  },
  'Re-Quote': {
    background: '#FFF0D9',
    color: '#484848',
  },
  'Re-Quoted': {
    background: '#FFF0D9',
    color: '#484848',
  },
  'Discussion & Negotiation': {
    background: '#FFF8C3',
    color: '#484848',
  },
  Samples: {
    background: '#E6FFAA',
    color: '#484848',
  },
  'Re-Sample': {
    background: '#E6FFAA',
    color: '#484848',
  },
  'Sample Decision': {
    background: '#BCFB6C',
    color: '#484848',
  },
  'RFQ Won': {
    background: '#70E77C',
    color: '#101010',
  },
  'RFQ Lost': {
    background: '#FFCF76',
    color: '#030303',
  },
  Nurturing: {
    background: '#BCFB6C',
    color: '#484848',
  },
  Regret: {
    background: '#FFA4A4',
    color: '#202020',
  },
  Rejected: {
    background: '#FFA4A4',
    color: '#202020',
  },
  'RFQ Inspection': {
    background: '#FF6262',
    color: '#F6F6F6',
  },
  RFAI: {
    background: '#FF8359',
    color: '#FFFFFF',
  },
  'RFQ Verified': {
    background: '#FFCB98',
    color: '#484848',
  },
  'Vendor Scouting': {
    background: '#FFDDB7',
    color: '#484848',
  },
  'Shared to Vendor': {
    background: '#FFE6CE',
    color: '#484848',
  },
  'Price Submission': {
    background: '#FFF0D9',
    color: '#484848',
  },
  'Price Negotiation': {
    background: '#FBFFE5',
    color: '#484848',
  },
  'Price Negotiation (Re-Quote)': {
    background: '#FFF8C3',
    color: '#484848',
  },
  'Submission to OPS': {
    background: '#A6F343',
    color: '#393939',
  },
  NQS: {
    background: '#FF6767',
    color: '#F3F3F3',
  },
  'Margin Profile': {
    background: '#FF8359',
    color: '#FFFFFF',
  },
  'Price Nego (Sales)': {
    background: '#FFF0D9',
    color: '#484848',
  },
  'Quote Generation': {
    background: '#FBFFE5',
    color: '#484848',
  },
  'Quote Review': {
    background: '#E6FFAA',
    color: '#484848',
  },
  'Quote Submitted': {
    background: '#A6F343',
    color: '#393939',
  },
  QUOTE_REGRETTED: {
    background: '#FFA4A4',
    color: '#202020',
  },
  'Request For Samples': {
    background: '#FF6767',
    color: '#F3F3F3',
  },
  Assigned: {
    background: '#FF8359',
    color: '#FFFFFF',
  },
  Communicated: {
    background: '#FFF0D9',
    color: '#484848',
  },
  'In Progress': {
    background: '#FBFFE5',
    color: '#484848',
  },
  Dispatched: {
    background: '#BCFB6C',
    color: '#000000',
  },
  Delivered: {
    background: '#70E77C',
    color: '#000000',
  },
  'PO Checked': {
    background: '#FF6262',
    color: '#FFFFFF',
  },
  'PO Generated': {
    background: '#FFB48A',
    color: '#FFFFFF',
  },
  'SO Estimated with dates': {
    background: '#FFCB98',
    color: '#000000',
  },
  'SO Shared': {
    background: '#FFDDB7',
    color: '#484848',
  },
  'Artwork Approval Client': {
    background: '#FFF0D9',
    color: '#484848',
  },
  'Artwork Revision': {
    background: '#FBFFE5',
    color: '#484848',
  },
  'Artwork Re-approval Client': {
    background: '#FFF8C3',
    color: '#484848',
  },
  'Artwork Approved': {
    background: '#E6FFAA',
    color: '#484848',
  },
  'PO Received': {
    background: '#FF8359',
    color: '#000000',
  },
  'SKU Checked and Vetted': {
    background: '#FFF0D9',
    color: '#000000',
  },
  'Estimated Date Confirmation': {
    background: '#FBFFE5',
    color: '#000000',
  },
  'SO Generation': {
    background: '#E6FFAA',
    color: '#000000',
  },
  'PO Generation': {
    background: '#A6F343',
    color: '#000000',
  },
  'PO Created': {
    background: '#FF6262',
    color: '#FFFFFF',
  },
  'PO Shared': {
    background: '#FF8359',
    color: '#FFFFFF',
  },
  'Artwork Verification': {
    background: '#FFB48A',
    color: '#000000',
  },
  'Artwork Verified': {
    background: '#FFCB98',
    color: '#000000',
  },
  'Production Planned': {
    background: '#FFDDB7',
    color: '#000000',
  },
  'Production Started': {
    background: '#FFE6CE',
    color: '#000000',
  },
  'Under Production (25%)': {
    background: '#FFF0D9',
    color: '#000000',
  },
  'Under Production (50%)': {
    background: '#FFF0D9',
    color: '#000000',
  },
  'Under Production (75%)': {
    background: '#FFF8C3',
    color: '#000000',
  },
  'Ready for Dispatch': {
    background: '#E6FFAA',
    color: '#000000',
  },
  'Partially Delivered': {
    background: '#70E77C',
    color: '#000000',
  },
  Closed: {
    background: '#00970F',
    color: '#FFFFFF',
  },
  'Artwork Generation': {
    background: '#FF8359',
    color: '#000000',
  },
  'Artwork Internal Check': {
    background: '#FFCB98',
    color: '#000000',
  },
  'Artwork Approval': {
    background: '#FFDDB7',
    color: '#000000',
  },
  'Artwork Revision Vendor': {
    background: '#FFF0D9',
    color: '#000000',
  },
  'Artwork Re-approval': {
    background: '#FFDDB7',
    color: '#000000',
  },
};